import XAPI, { Agent, Context, TinCanLaunchData } from "@xapi/xapi";
import { ExtendedLanguageInfo } from "./getExtendedLanguageInfo";

export function trackLanguageChoice(language: ExtendedLanguageInfo) {
  const tinCanLaunchData: TinCanLaunchData = XAPI.getTinCanLaunchData();
  const endpoint: string = tinCanLaunchData.endpoint || "";
  const auth: string = tinCanLaunchData.auth || "";
  const xapi: XAPI = new XAPI(endpoint, auth, "1.0.0");

  const contextActivities: Context["contextActivities"] = {
    ...(tinCanLaunchData.grouping
      ? {
          grouping: [
            {
              id: tinCanLaunchData.grouping as string,
              objectType: "Activity"
            }
          ]
        }
      : {})
  };

  return xapi.sendStatement({
    actor: tinCanLaunchData.actor as Agent,
    context: {
      registration: tinCanLaunchData.registration,
      ...(Object.keys(contextActivities).length ? contextActivities : {})
    },
    verb: {
      id: "http://spongelearning.com/verbs/selected-language",
      display: {
        "en-GB": "selected the language"
      }
    },
    object: {
      objectType: "Activity",
      id: `http://spongelearning.com/languages/${language.htmlLangValue}`,
      definition: {
        name: {
          "en-GB": language.name
        }
      }
    }
  });
}
